import { createSetAtom } from '~shared/atoms/utils/createSetAtom';

export const selectedPublicIdsAtom = createSetAtom<string>(new Set());
